module.exports = __webpack_public_path__ + "static/scale-model-of-statue-\"dewey-weber\"-in-torrance-california-57c225ff56246eeebb67a0fe960ba6f7.png";